import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { getFooterCopyrightText } from '../utils/copyright';
import { DEFAULT_BRAND_LOGO } from '../contexts/OrganizationBrandingContext';

const Footer = () => {
  const copyrightText = getFooterCopyrightText();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 3,
        px: 2,
        backgroundColor: (theme) => theme.palette.mode === 'light' 
          ? theme.palette.grey[50] 
          : theme.palette.grey[900],
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        textAlign: 'center',
        boxShadow: '0 -1px 3px rgba(0,0,0,0.1)'
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ 
          mb: 1,
          fontWeight: 500
        }}
      >
        {copyrightText}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: '0.875rem' }}
      >
        For soccer league matters:{' '}
        <Link
          href="mailto:info@basoccer.ca"
          color="primary"
          underline="hover"
          sx={{ 
            fontWeight: 500,
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          info@basoccer.ca
        </Link>
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: '0.875rem' }}
      >
        For technical support:{' '}
        <Link
          href="mailto:info@quailgame.com"
          color="primary"
          underline="hover"
          sx={{ 
            fontWeight: 500,
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          info@quailgame.com
        </Link>
      </Typography>
      <Box
        sx={{
          mt: 1,
          display: 'flex',
          justifyContent: 'center',
          gap: 2
        }}
      >
        <Link
          component={RouterLink}
          to="/privacy"
          color="text.secondary"
          underline="hover"
          sx={{ fontSize: '0.875rem' }}
        >
          Privacy Policy
        </Link>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
          •
        </Typography>
        <Link
          component={RouterLink}
          to="/terms"
          color="text.secondary"
          underline="hover"
          sx={{ fontSize: '0.875rem' }}
        >
          Terms of Service
        </Link>
      </Box>
      <Link
        href="https://www.quailgame.com"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="text.secondary"
        sx={{ mt: 1.5, display: 'inline-flex', alignItems: 'center', gap: 0.75, fontSize: '0.8125rem' }}
      >
        <Box
          component="img"
          src={DEFAULT_BRAND_LOGO}
          alt=""
          sx={{ height: 24, width: 'auto', display: 'block' }}
        />
        <span>
          Powered by{' '}
          <Box component="strong" sx={{ color: 'text.primary' }}>QuailGame</Box>
        </span>
      </Link>
    </Box>
  );
};

export default Footer;